import * as React from 'react'

function SvgStarHalfIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.386 8.34 12 1 8.614 8.34l-8.027.952 5.935 5.488-1.575 7.928L12 18.76l7.053 3.948-1.575-7.928 5.935-5.488-8.027-.952Zm3.485 2.427-4.833-.573L12 5.775v10.693l4.247 2.377-.949-4.773 3.573-3.305Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgStarHalfIcon
